import MuiTooltip, { TooltipProps } from '@mui/material/Tooltip';

export interface ITooltipProps extends TooltipProps {}

const Tooltip = (props: ITooltipProps): JSX.Element => {
  return <MuiTooltip {...props} />;
};

export default Tooltip;
